// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/low-ceiling-circuit-height.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/low-ceiling-circuit-height/low-ceiling-circuit-height.js';

mount([g0]);
